import { useCallback, useEffect, useRef, useState } from "react";

export function useInView(options?: IntersectionObserverInit) {
  const [node, setNode] = useState<HTMLDivElement | null>(null);
  const [inView, setInView] = useState(false);
  const optionsRef = useRef(options);
  optionsRef.current = options;

  const ref = useCallback((element: HTMLDivElement | null) => {
    setNode(element);
  }, []);

  useEffect(() => {
    if (!node || inView) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      optionsRef.current ?? { rootMargin: "200px" }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [node, inView]);

  return { ref, inView } as const;
}
